import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-primary to-secondary rounded-lg">
                <i className="ri-car-line text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold">대전렌트카</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              대전 지역 최고의 렌터카 서비스를 제공합니다. 합리적인 가격과 최상의 서비스로 고객님의 여행을 책임집니다.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">빠른 링크</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  홈
                </Link>
              </li>
              <li>
                <Link to="/compact-car" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  소형차
                </Link>
              </li>
              <li>
                <Link to="/midsize-car" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  중형차
                </Link>
              </li>
              <li>
                <Link to="/fullsize-car" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  대형차
                </Link>
              </li>
              <li>
                <Link to="/suv-car" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  SUV
                </Link>
              </li>
              <li>
                <Link to="/van-car" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  승합차
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">연락처</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-primary mt-0.5 flex-shrink-0"></i>
                <div>
                  <p className="text-sm text-gray-400">전화</p>
                  <a href="tel:010-5437-1535" className="text-sm text-white hover:text-primary transition-colors cursor-pointer">
                    010-5437-1535
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-primary mt-0.5 flex-shrink-0"></i>
                <div>
                  <p className="text-sm text-gray-400">이메일</p>
                  <a href="mailto:juni101187@gmail.com" className="text-sm text-white hover:text-primary transition-colors cursor-pointer break-all">
                    juni101187@gmail.com
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-primary mt-0.5 flex-shrink-0"></i>
                <div>
                  <p className="text-sm text-gray-400">주소</p>
                  <p className="text-sm text-white">대전광역시 서구 신갈마로141번길10</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h3 className="text-lg font-semibold mb-4">영업시간</h3>
            <ul className="space-y-2">
              <li className="flex justify-between text-sm">
                <span className="text-gray-400">평일</span>
                <span className="text-white">09:00 - 18:00</span>
              </li>
              <li className="flex justify-between text-sm">
                <span className="text-gray-400">토요일</span>
                <span className="text-white">09:00 - 18:00</span>
              </li>
              <li className="flex justify-between text-sm">
                <span className="text-gray-400">일요일/공휴일</span>
                <span className="text-white">09:00-18:00</span>
              </li>
            </ul>
            <div className="mt-6">
              <Link
                to="/location"
                className="inline-flex items-center space-x-2 text-sm text-primary hover:text-secondary transition-colors cursor-pointer"
              >
                <i className="ri-map-pin-2-line"></i>
                <span>오시는 길 보기</span>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-gray-700">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="text-xs md:text-sm text-gray-400 text-center sm:text-left">
              © 2024 대전렌트카. All rights reserved.
            </p>
            <div className="flex items-center space-x-4 md:space-x-6">
              <Link to="/terms" className="text-xs md:text-sm text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                보험약관
              </Link>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-xs md:text-sm text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
